"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const Guardia_1 = require("../Guardia");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 * UseAssignedAppointment busca en la DB el único appointment de guardia activo que debería tener el paciente.
 * En caso de tener más de uno, traerá el último.
 * Si se intenta utilizar con un paciente que no tiene medicalRecords, quedará con isIdle='true' pero no saldrá de eso.
 *
 * @param firestore
 * @param uid
 * @param country
 * @param options suscribe: boolean, permite subscripirte y recibir cambios en tiempo real
 * @param queryOptions
 * @param assignation
 * @returns UseQueryResult<IAppointment | undefined, FirestoreError>
 */
function useAssignedAppointment(firestore, uid, country, options, queryOptions, assignation) {
    const assignationId = (0, Guardia_1.useAssignedAssignationId)(firestore, uid);
    const path = {
        "AR": "assignations/online_clinica_medica/bag/",
        [country]: `assignations/bag/${country}/`
    };
    let appointmentRef;
    if (assignation && assignation.length > 0 && assignation) {
        appointmentRef = (0, firestore_2.doc)(firestore, path[country], assignation);
    }
    else if (assignationId.data) {
        appointmentRef = (0, firestore_2.doc)(firestore, path[country], (assignation && assignation.length > 0 && assignation) || assignationId.data);
    }
    const appointment = (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Guardia({
        name: "GuardAssignedAppointment",
        path: `${path[country]}/${assignationId.data}`
    }, [country, uid, assignationId.data]), appointmentRef, options, {
        ...queryOptions,
        enabled: assignationId.isSuccess && !!assignationId.data && queryOptions?.enabled,
    });
    // 🥳 Salió todo bien pero el dato igual podría venir vacío, ten precaución
    return appointment;
}
exports.default = useAssignedAppointment;
